import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import styles from './Container.module.scss';

export interface IContainerProps {
  className?: string;
  children: ReactNode;
}

export const Container: FC<IContainerProps> = (props) => {
  const { children, className } = props;

  return <div className={clsx(styles.Container, className)}>{children}</div>;
};
